(function() {
  'use strict';

  angular.module('app').factory('RoutesTerminalService', RoutesTerminalService);

  RoutesTerminalService.$inject = ['$rootScope', 'API'];

  function RoutesTerminalService($rootScope, API) {
    var service = {};
    /**
     * This callback type is called `requestCallback` and is displayed as a global symbol.
     *
     * @callback requestCallback
     * @param {boolean} success
     * @param {Object} data
     */
    /**
     * @typedef MultiLanguageObject
     * @type {Object}
     * @property {string} en - String on English
     * @property {string} pl - String on Polish
     * @property {string} ru - String on Russian
     * @property {string} uk - String on Ukrainian
     */

    /**
     * Return list of Routes for Terminals
     *
     * @param {object} params - Parameters
     * @param {string} params.page - List page number
     * @param {string} params.count - Objects on page
     * @param {string} params.date - Route date filtering
     * @param {string} params.terminal_id - terminal Id filtering
     * @param {'all'|'yes'|'no'} params.active - Filter by active flag
     * @param {'date'} params.sort - Sort field name
     * @param {'asc'|'desc'} params.order - Sort direction
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetRoutesTerminal = function(params, callback) {
      API.get('/routes/terminal' + (params ? ('?' + paramsToUrlQueryEncodeURIComponent(params)) : ''), function(success, data) {
        callback(success, data);
      });
    };

    /**
     * active (integer, optional): Tank is active flag = ['0', '1'],
     * comment (string, optional): Comment ,
     * date (string, optional): Route date in format YYYY-MM-DD (if null or not exists - create route on current date) ,
     */
    /**
     * Add route for Terminal
     *
     * @param {object} route - Route for Terminal data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddRoute = function(route, callback) {
      API.post('/routes/terminal', route, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return Route for Terminal Info
     *
     * @param {string} routeID - Route Id
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetRoute = function(routeID, callback) {
      API.get('/routes/terminal/' + routeID, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify Route for Terminal data
     *
     * @param {string} routeID - Route Id
     * @param {object} route - Route for Terminal data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateRoute = function(routeID, route, callback) {
      API.patch('/routes/terminal/' + routeID, route, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return Route operations list
     *
     * @param {string} routeID - Route Id
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetRouteOperations = function(routeID, callback) {
      API.get('/routes/terminal/' + routeID + '/operations', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * scheduled* (string, optional): Scheduled time in HH:mm format ,
     * comment (string, optional): Comment ,
     * status* (string, optional): Operation status = ['pending', 'processed', 'failed', 'canceled'],
     * type* (string, optional): Operation type = ['sale-fuel-to-tank']
     * details (inline_model_20, optional): Operation details (depends on type) ,
     *      product_volume (number, optional): Current product volume (for 'sale-fuel-to-tank' type) ,
     quantity* (number, optional): Quantity which will be fill ,
     tank_id* (string, optional): Tank Id (for 'sale-fuel-to-tank' type)
     */

    /**
     * Add operations to Route
     *
     * @param {string} routeID - Route Id
     * @param {object} routeOperation - Route operation data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddRouteOperation = function(routeID, routeOperation, callback) {
      API.post('/routes/terminal/' + routeID + '/operations', routeOperation, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return Route operation data
     *
     * @param {string} routeID - Route Id
     * @param {string} operationID - Operation Id
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetRouteOperation = function(routeID, operationID, callback) {
      API.get('/routes/terminal/' + routeID + '/operations/' + operationID, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify Route operation data
     *
     * @param {string} routeID - Route Id
     * @param {string} operationID - Operation Id
     * @param {object} routeOperation - Route operation data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateRouteOperation = function(routeID, operationID, routeOperation, callback) {
      API.patch('/routes/terminal/' + routeID + '/operations/' + operationID, routeOperation, function(success, data) {
        callback(success, data);
      });
    };
    return service;
  }
})();
